import React, { useRef, useState, useEffect } from 'react';
import anime from 'animejs/lib/anime.es.js';
import { gtmTracking, gtm4Tracking } from '../../js/helpers';
import './SocialShare.scss'

const SocialShare = () => {
  const tooltipRef = useRef();
  const tooltipShareContentRef = useRef();
  const shareUrlRef = useRef();

  const [toggleSocialTooltip, settoggleSocialTooltip] = useState(false);
  const [toggleCopyTooltip, settoggleCopyTooltip] = useState(false);

  const hidePopupHandler = () => {
    settoggleCopyTooltip(true);
    setTimeout(() => {
      settoggleCopyTooltip(false);
    }, 1500);
  };

  const copyToClipboardHandler = async () => {
    if ('clipboard' in navigator) {
      await navigator.clipboard.writeText(window.location.href);
      hidePopupHandler();
    } else {
      shareUrlRef.current.select();
      document.execCommand('copy');
      hidePopupHandler();
    }
  };

  const shareTooltipHandler = () => {
    settoggleSocialTooltip(() => !toggleSocialTooltip);
  };

  const changeHandler = (e) => {
    if (!tooltipRef.current.contains(e.target)) {
      settoggleSocialTooltip(false);
    }
  };

  useEffect(() => {
    if (!toggleSocialTooltip) {
      return;
    }

    anime({
      targets: tooltipShareContentRef.current,
      opacity: [0, 1],
      easing: 'easeOutExpo',
    });

    document.addEventListener('click', changeHandler);
    return () => document.removeEventListener('click', changeHandler);
    
  }, [toggleSocialTooltip]);

  const classActive = toggleSocialTooltip ? 'tos-footer__button--active' : '';
  // const ogTitle = document.querySelector('meta[property="og:title"]').content ?? '';
  const ogTitle = '';

  const shareLinkedin = () => {
    gtmTracking('share', 'linkedin', 'share content');
    window.open('https://www.linkedin.com/sharing/share-offsite/?url=' + window.window.location.href + '&title=' + ogTitle, '', '_blank, width=500, height=500, resizable=yes, scrollbars=yes'); return false;
  }

  const shareTwitter = () => {
    gtmTracking('share', 'twitter', 'share content');
    window.open('https://twitter.com/share?url=' + window.window.location.href + '&text=' + ogTitle, '', '_blank, width=500, height=500, resizable=yes, scrollbars=yes'); return false;
  }

  const shareFacebook = () => {
    gtmTracking('share', 'facebook', 'share content');
    window.open('https://www.facebook.com/sharer.php?u=' + window.window.location.href, '', '_blank, width=500, height=500, resizable=yes, scrollbars=yes'); return false;
  }

  return (
    <div className='tos-footer__share' ref={tooltipRef}>
      <button
        className={`tos-footer__button ${classActive}`}
        onClick={shareTooltipHandler}
		aria-label="Share"
      >
        <div className='tos-footer__button-icon'>
          <svg
            width='15'
            height='12'
            viewBox='0 0 15 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M9.375 3.82357C4.96874 3.82357 1.12499 6.88246 0.0562401 11.2412L0 11.4706C2.4 9.02353 5.66251 7.64706 9.05626 7.64706H9.37499V11.4706L15 5.73529L9.37499 0L9.375 3.82357Z'
              fill='white'
            />
          </svg>
        </div>
        <span>Share</span>
      </button>

      <div
        className={`tos-footer__tooltip tos-footer__tooltip--share ${
          toggleSocialTooltip ? 'tos-footer__tooltip--open' : ''
        }`}
        ref={tooltipShareContentRef}
      >
        <button
          className='tos-footer__tooltip-close'
          onClick={() => settoggleSocialTooltip(false)}
        >
          &times;{' '}
        </button>
        <span className='tos-footer__share-text'>Share this page</span>

        <div className="tos-footer__share-wrapper">
          <ul className='tos-footer__share-social social-list'>
            <li className='social-list--element social-list-element--addthis social-list--element--linkedin'>
              <button
                className='addthis_share_button linkedin'
                data-service='linkedin'
				aria-label='linkedin'
                onClick={() => {
                  gtm4Tracking({
										event: 'GA4_event_c_tfs_share',
                    sharing_method: 'linkedin'
									});
                  shareLinkedin();
                }}
              >
                <svg
                  width='20'
                  height='20'
                  viewBox='0 0 20 20'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M18 0H2C0.89543 0 0 0.89543 0 2V18C0 19.1046 0.89543 20 2 20H18C19.1046 20 20 19.1046 20 18V2C20 0.89543 19.1046 0 18 0ZM4 4.56404C4 5.42749 4.70032 6.12899 5.56637 6.12899C6.4297 6.12899 7.13184 5.42749 7.13184 4.56404C7.13184 3.7015 6.4297 3 5.56637 3C4.70123 3 4 3.70059 4 4.56404ZM4.25044 16H6.93695V7.36366H4.25044V16ZM17 16H14.3153V11.8001C14.3153 10.7984 14.2971 9.51001 12.9192 9.51001C11.5213 9.51001 11.3064 10.6009 11.3064 11.7273V16H8.62172V7.36366H11.1989V8.54374H11.2354C11.5942 7.86499 12.4703 7.14894 13.7771 7.14894C16.4973 7.14894 17 8.93771 17 11.2633V16Z'
                    fill='white'
                  />
                </svg>
              </button>
            </li>
            <li className='social-list--element social-list-element--addthis social-list--element--twitter'>
              <button
                className='addthis_share_button twitter'
                data-service='twitter'
				aria-label='twitter'
                onClick={() => {
                  gtm4Tracking({
										event: 'GA4_event_c_tfs_share',
                    sharing_method: 'twitter'
									});
                  shareTwitter();
                }}
              >
                <svg
                  width='20'
                  height='20'
                  viewBox='-220 60 1600 1100'
                  fill='white'
                  xmlns='http://www.w3.org/2000/svg'
                  className='icon-x'
                  preserveAspectRatio='xMidYMid meet'
                >
                  <path
                    d='M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z'
                    fill='#032c77'
                  />
                </svg>
              </button>
            </li>
            <li className='social-list--element social-list-element--addthis social-list--element--facebook'>
              <button
                className='addthis_share_button facebook'
                data-service='facebook'
				aria-label='facebook'
                onClick={() => {
                  gtm4Tracking({
										event: 'GA4_event_c_tfs_share',
                    sharing_method: 'facebook'
									});
                  shareFacebook();
                }}
              >
                <svg
                  width='20'
                  height='20'
                  viewBox='0 0 20 20'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M18 0H2C0.89543 0 0 0.89543 0 2V18C0 19.1046 0.89543 20 2 20H18C19.1046 20 20 19.1046 20 18V2C20 0.89543 19.1046 0 18 0ZM8 10.4706V18H11V10.4706H13.5629L13.9741 7.64706H11V6.44047C11 5.35812 11.3053 4.82353 12.339 4.82353H14V2.12329L13.9825 2.12097C13.6836 2.08142 13.0684 2 11.925 2C9.48967 2 8 3.26024 8 6.13082V7.64706H5V10.4706H8Z'
                    fill='white'
                  />
                </svg>
              </button>
            </li>
          </ul>
          <div className='tos-footer__share-copy'>
            <textarea
              className='tos-footer__share-url'
              ref={shareUrlRef}
              value={window.location.href}
              readOnly
            />
            <button
              className='tos-footer__share-copy-btn'
              onClick={() => {
                gtm4Tracking({
                  event: 'GA4_event_c_tfs_share',
                  sharing_method: 'copy link'
                });
                copyToClipboardHandler();
              }}
            >
              {toggleCopyTooltip && (
                <span className='tos-footer__share-text-helper'>Copied</span>
              )}
              copy
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialShare;

